import { useEffect } from "react"
import useLazyQuery from "./useLazyQuery"

/**
 * The same as useLazyQuery, except query gets called once automatically
 * @param url
 * @param method
 * @returns
 */
const useQuery = <InputBody = Object, OutputBody = Object>(url: string, method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE", body?: InputBody) => {
	const { query, data, loading, error } = useLazyQuery<InputBody, OutputBody>(url, method)
	useEffect(() => {
		query({ body })
	}, [body, query])
	return { query, data, loading, error }
}
export default useQuery
